// extracted by mini-css-extract-plugin
export default {"container":"CI-z","error":"DI-z","disabled":"EI-z","submit":"FI-z","option":"GI-z","success":"HI-z","failure":"II-z"};